<template>
    <div class="cover-content table-wrapper">
        <el-tabs v-model="applicantStatus" type="card" @tab-click="tabChange">
            <el-tab-pane label="待办秘钥项目" name="0"></el-tab-pane>
            <el-tab-pane label="已办秘钥项目" name="1"></el-tab-pane>
            <el-tab-pane label="已驳回" name="2"></el-tab-pane>
            <el-tab-pane label="全部" name=""></el-tab-pane>
        </el-tabs>
        <!-- <high-search> -->
        <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="75" label-position="right" style="margin-bottom: 24px">
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="项目名称:" :label-width="78">
                        <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="工程类别:">
                        <Select v-model="formInline.projectType" filterable clearable>
                            <Option v-for="item in common.projectTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>

                        <!--<RadioGroup v-model="formInline.projectType">-->
                        <!--<Radio label="1" value='1'>房建</Radio>-->
                        <!--<Radio label="2" value='2'>市政</Radio>-->
                        <!--<Radio label="3" value='3'>其他</Radio>-->
                        <!--</RadioGroup>-->
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目所在地:">
                        <place-select v-model="formInline.areaCode"></place-select>
                        <!--<Select v-model="formInline.areaCode" transfer placeholder="请选择地区">-->
                        <!--<Option v-for="(item,index) in area" :value="item.value" :key="index">{{ item.label }}</Option>-->
                        <!--</Select>-->
                    </FormItem>
                </Col>
                <Col span="6" class="high-search">
                    <FormItem :label-width="0">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16"  v-show="open">
                <Col span="6">
                    <FormItem label="申请时间:">
                        <DatePicker placeholder="请选择申请时间" v-model="formInline.createTime" @on-change='handleStartDate'></DatePicker>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="申请人:" :label-width="78">
                        <Input v-model="formInline.applicantName" placeholder="请输入申请人"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="秘钥状态:">
                        <RadioGroup v-model="formInline.disabled">
                            <Radio label="" value=''>全部</Radio>
                            <Radio :label="1" :value='1'>停用</Radio>
                            <Radio :label="0" :value='0'>运行中</Radio>
                        </RadioGroup>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="施工许可证号：" prop="builderLicenseNum">
                        <Input v-model="formInline.builderLicenseNum" placeholder="请输入施工许可证号"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="8">
                    <!--<Button type="primary" style="margin-right: 12px" @click="handleKey">申请秘钥</Button>-->
                    <Button :loading="eLoading" type="primary" @click="handleExport" icon="ios-exit-outline">导出</Button>
                </Col>
            </Row>
        </Form>
        <!-- </high-search> -->
        <div class='cover-table'>
            <Table border style="width: 100%;" :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="token">
                    <span v-if="row.sendSmsStatus == 1">{{row.token}}</span>
                </template>
                <template slot-scope="{ row, index }" slot="providerCode">
                    <span v-if="row.sendSmsStatus == 1">{{row.providerCode}}</span>
                </template>
                <template slot-scope="{ row, index }" slot="disabled">
                    <template v-if="row.sendSmsStatus == 1 && row.token && row.providerCode">
                        <span v-if="row.disabled == 1">停用</span>
                        <span v-else-if="row.disabled == 0">运行中</span>
                        <span v-else>未申请</span>
                    </template>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <template v-if="row.disabled == 1 || row.disabled == 0"> <!-- 登记了秘钥 -->
                        <Button v-if="row.sendSmsStatus != 2" type="text" size="small" :loading="row.loading" @click="sendMi(row, index)" class="pointer">
                            <span v-if="!row.loading">发送秘钥</span>
                            <span v-else>发送中...</span>
                        </Button>
                        <Button v-if="row.sendSmsStatus == 1" type="text" size="small"  class="pointer"  @click="handleConfirm(row)">{{row.disabled == 1 ? '启用' : '停用'}}</Button>
                        <Button type="text" size="small"  class="pointer"  @click="djDetail(row)">登记详情</Button>
                        <Button v-if="row.sendSmsStatus != 1 && row.sendSmsStatus != 2" type="text" size="small"  class="pointer"  @click="handleDeal(row)">驳回</Button>
                    </template>
                    <Button type="text" size="small" v-if="row.sendSmsStatus != 2" class="pointer"  @click="jumpDetail(row)">详情</Button>
                </template>
            </Table>
            <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
            </Page>
        </div>
        <Modal v-model="lModal"  :mask-closable='false' width="650">
            <p slot="header">
                <span>请填写驳回原因</span>
            </p>
            <div>
                <Form ref="formLine" class="form-list" :model="formLine" :rules="ruleLine" inline :label-width="100" label-position="right">
                    <Row :gutter="24">
                        <Col span="24">
                            <FormItem label="驳回原因" prop="rejectReason">
                                <Input type="textarea" :autosize="{minRows:3,maxRows: 5}"  v-model="formLine.rejectReason" ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer" style="text-align: center">
                <Button type="primary" :loading="loadingL" @click="handleSubmit('formLine')">驳 回</Button>
                <Button @click="lModal=false" style="margin-left: 16px">取 消</Button>
            </div>
        </Modal>
        <Modal
                v-model="myVisiable"
                title="项目秘钥申请"
                :loading="loading"
                :footer-hide='true'
                :mask-closable='false'
                width='800'
        >
            <Form ref="modeForm" :model="modeForm" :rules="modeFormRules" inline :label-width="240" class="form-list key__form">
                <Row :gutter="16">
                    <Col span="24">
                        <FormItem label="请选择项目：" prop="projectId">
                            <Select
                                    v-model="modeForm.projectId"
                                    placeholder="请选择项目"
                                    filterable clearable
                                    :remote-method="remoteMethodK"
                                    @on-change="handleSelectK"
                                    @on-clear="handleCleartK"
                                    :loading="loadingK">
                                <Option v-for="(option, index) in projectListK" :value="option.value" :key="index">{{option.label}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目名称：">
                            <span>{{modeForm.name}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="施工许可证号：">
                            <span>{{modeForm.buildPermitCode}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目所在地区：">
                            <span>{{modeForm.areaName}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目类别：">
                            <!--<span>{{common.transfer(modeForm.projectType, common.projectTypes)}}</span>-->
                            <span>{{modeForm.projectType}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目状态：">
                            <span>{{common.transfer(modeForm.prjStatus, common.prjStatusS)}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="施工总承包单位名称：">
                            <span>{{modeForm.contractorCorpName}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="施工总承包单位统一社会信用代码：">
                            <span>{{modeForm.contractorCorpCode}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目开工日期（计划开工日期）：">
                            <span>{{modeForm.startDate}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目竣工日期（计划竣工日期）：">
                            <span>{{modeForm.completeDate}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="总投资（万元）：">
                            <span>{{modeForm.invest}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="总面积（平方米）：">
                            <span>{{modeForm.buildingArea}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="建设单位名称：">
                            <span>{{modeForm.buildCorpName}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="建设单位统一社会信用代码：">
                            <span>{{modeForm.buildCorpCode}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目经理：">
                            <span>{{modeForm.pmName}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="总监理工程师：">
                            <span>{{modeForm.supervisingEngineerName}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="设备安装公司名称：">
                            <span>{{modeForm.equipmentCompanyName}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="设备安装公司电话：">
                            <span>{{modeForm.equipmentCompanyMobile}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目实名制负责人姓名：">
                            <span>{{modeForm.applicantName}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目实名制负责人联系电话：">
                            <span>{{modeForm.applicantMobile}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目实名制负责人邮箱：">
                            <span>{{modeForm.email}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="备注：">
                            <span>{{modeForm.remark}}</span>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem>
                    <Button type="primary" :loading="loadingK" @click="asyncOK" style="width: 100px; margin-right: 20px">提交</Button>
                    <Button @click="asyncCancel" style="width: 100px">取消</Button>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<style scoped lang="less">
.key__form{
    padding: 0 20px;
    .ivu-form-item{
        margin-bottom: 20px;
    }
}
</style>
<script>
    import { mapState } from 'vuex';
    import tableMixin from '@/components/tableMixin';
    const getCookie = (key) => {
      let str = document.cookie
      str = str.split('; ')
      if (str.length > 0) {
        const a = str.find((it) => it.indexOf(key) > -1)
        if (a) {
          return a.split('=')[1]
        } else {
          return ''
        }
      } else {
        return ''
      }
    };
    const validStrForPhoneNum = (rule, value, callback) => {
        let r = '';
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (value === '' || value === undefined) {
            r = '请输入申请人联系电话'
        } else if (typeof value === 'string' && !reg.test(value)) {
            r = '手机号格式错误'
        }
        if (r) {
            callback(new Error(r))
        } else {
            callback()
        }
    };
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                // 驳回 <
                tProjectTokenId: '',
                lModal: false,
                loadingL: false,
                formLine: {
                    rejectReason: ''
                },
                ruleLine: {
                    rejectReason: [
                        { required: true, message: '驳回原因不能为空', trigger: 'blur' }
                    ],
                },
                // >
                /* 秘钥< */
                loadingM: false,
                myVisiable: false,
                loadingK: false,
                projectListK: [], // 选择项目列表
                modeForm: {
                    projectId: '', // 项目名称
                },
                modeFormRules: {
                    projectId: [
                        { required: true, type:'any', message: '请选择项目名称', trigger: 'change' }
                    ],
                    // applicantName: [
                    //     { required: true, message: '请输入申请人姓名', trigger: 'blur' }
                    // ],
                    // applicantMobile: [
                    //     { required: true, validator: validStrForPhoneNum, trigger: 'blur' }
                    // ],
                    // email: [
                    //     { required: true, message: '邮箱地址不能为空', trigger: 'blur' },
                    //     { type: 'email', message: '邮箱地址格式不正确', trigger: 'blur' }
                    // ],
                },
                /* 秘钥> */
                open: false,
                applicantStatus: '0',
                formInline:{
                    builderLicenseNum: '',
                    startNum: 1,
                    size: 10,
                    applicantName: '', //申请人姓名
                    createTime: '', //申请时间
                    disabled: '',			// 默认传0：启用，1停用
                    projectName: '', //项目名称
                    projectType: '', //工程类别：1：房建，2市政，3其他
                    areaCode: getCookie('tenantAreaCode'), //区划代码 默认传：cookie里的：tenantAreaCode
                },
                tableColumns:[
                    { title: '序号', type: 'index', width: 70, fixed: 'left', align: 'center' },
                    { title: '项目名称', key: 'name', minWidth: 210 },
                    { title: '施工许可证号', key: 'builderLicenseNum', minWidth: 210, tooltip: true },
                    { title: '项目令牌', slot: 'token', minWidth:210, tooltip: true },
                    { title: '项目秘钥', slot: 'providerCode', minWidth: 180 },
                    { title: '秘钥状态', key: 'disabled', minWidth:120, slot: 'disabled' },
                    { title: '工程类别', key: 'category', minWidth: 100, },
                    { title: '注册属地', key: 'areaName', minWidth: 250 },
                    // { title: '软件供应商名称', key: 'supplierName', minWidth: 180 },
                    { title: '申请时间', key: 'createTime', minWidth: 180 },
                    { title: '申请人', key: 'applicantName', minWidth: 100 },
                    { title: '联系电话', key: 'applicantMobile', minWidth:140 },
                    { title: '邮箱', key: 'email', minWidth: 180 },
                    { title: '建设单位', key: 'buildCorpName', minWidth: 210},
                    { title: '施工单位', key: 'contractorCorpName', minWidth: 210 },
                    { title: '施工单位统一社会信用代码', key: 'contractorCorpCode', minWidth: 210 },
                    { title: '操作', slot: 'action', fixed: 'right', align: 'center', minWidth: 140 }
                ],
                tableData: []
            };
        },
        computed:{
            ...mapState(['navList','area','citys']),
        },
        created(){
            this.formInline.projectName = this.$route.query.projectName ? this.$route.query.projectName : '';
        },
        mounted(){

        },
        watch: {
            myVisiable(val) {
                if(!val) {
                    this.asyncCancel()
                }
            }
        },
        methods: {
            // tab切换
            tabChange(val){
                this.page=1;
                this.applicantStatus = val.name;
                this.getTableData(val.name)
            },
            // 驳回
            handleDeal(row){
                this.lModal = true;
                this.tProjectTokenId = row.id;
                this.$refs.formLine.resetFields();
            },
            // 驳回确认
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    this.loadingL = true;
                    this.axios({
                        method: 'GET',
                        url: '/project/sendRejectSms',
                        params: {
                            userName: localStorage.getItem('userName'),
                            tProjectTokenId: this.tProjectTokenId,
                            rejectReason: this.formLine.rejectReason,
                        },
                    }).then((response) => {
                        this.loadingL = false;
                        if(response.data.success){
                            this.lModal = false;
                            this.$Message.success('提交成功!');
                            this.getTableData()
                        }else {
                            this.$Message.warning(response.data.errorMsg);
                        }
                    }).catch( ()=> {
                        this.loadingL = false;
                    });
                })
            },
            // 登记详情
            djDetail(row){
                this.$router.push({
                    name: 'screctKeyDetail',
                    query: {
                        tProjectTokenId: row.id,
                        sendSmsStatus: row.sendSmsStatus,
                        applicantStatus: this.applicantStatus
                    }
                });
            },
            /*高级查询*/
            handleQuery() {
                this.keyWord=this.keyWord.replace(/'/g,'');
                this.page = 1;
                this.getTableData(this.applicantStatus);
            },

            /*新页数*/
            changePage(value) {
                this.page=value;
                this.getTableData(this.applicantStatus);
            },
             /*每页的条数*/
            pageSizeChange(value){
                this.pageSize=value;
                this.page=1;
                this.getTableData(this.applicantStatus);
            },
            // 详情
            jumpDetail(row){
                this.$router.push({
                    name: 'projectDetail',
                    query: {
                        projectId: row.projectId
                    }
                });
            },
            // 发送秘钥
            sendMi(row){
                row.loading = true;
                this.axios({
                    method: 'get',
                    url:'/project/sendSmsSecretKey',
                    params: {
                        userName: localStorage.getItem('userName'),
                        tProjectTokenId: row.id,
                    }
                }).then((res) => {
                    row.loading = false;
                    if(res.data.success) {
                        this.$Message.success('发送成功!');
                        this.getTableData();
                    }else {
                        this.$Modal.warning({
                            title: '提示',
                            content: res.data.errorMsg,
                            onOk:()=>{ }
                        });
                    }
                }).catch(()=>{
                    row.loading = false;
                })
            },
            // 选中项目
            handleSelectK(item) {
                let obj = this.projectListK.find(t => {
                    return t.value === item
                });
                this.axios({
                    method: 'get',
                    url:'/project/checkProjectIsRegister',
                    params: {
                        projectId: item,
                    }
                }).then((res) => {
                    if(res.data.data > 0) {
                        this.$Modal.warning({
                            title: '提示',
                            content: '您选择的项目已经申请过秘钥，请在列表中查询相关秘钥信息。',
                            onOk:()=>{
                                this.modeForm.projectId = '';
                            }
                        });
                    }else {
                        Object.assign(this.modeForm, obj)
                    }
                })
            },
            handleCleartK(){
                // let obj = {
                //     projectName: '', // 项目名称
                //     projectAreaCode: '', // 项目地区code
                //     projectType: '',
                //     areaName: '',
                //     buildCorpName: '',
                //     buildCorpCode: '',
                //     constructionName: '',
                //     buildName: '',
                //     buildCreditCode: '',
                //     projectId: '',
                // };
                this.modeForm = {
                    projectId: '',
                };
                // Object.assign(this.modeForm, obj)
            },
            // 选择项目搜索数据
            remoteMethodK(query){
                if (query !== '') {
                    this.projectListK = [];
                    this.loadingK = true;
                    this.axios({
                        method: 'get',
                        url:'/project/getProjectListByArea',
                        params: {
                            areaCode: localStorage.getItem('tenantAreaCode'),
                            projectName: query
                        }
                    }).then((res) => {
                        this.loadingK = false;
                        if(res.data && res.data.data) {
                            const obj = {
                                '01': '房屋建筑工程',
                                '02': '市政公用工程',
                                '03': '机电安装工程',
                                '04': '铁路工程',
                                '05': '公路工程',
                                '06': '港口与航道工程',
                                '07': '水利水电工程',
                                '08': '电力工程',
                                '09': '矿山工程',
                                '10': '冶炼工程',
                                '11': '化工石油工程',
                                '12': '通信工程',
                                '99': '其他',
                            };
                            res.data.data.forEach(item => {
                                item.value = item.id;
                                item.label = item.name;
                                item.projectName = item.name;
                                item.projectAreaCode = item.areaCode;
                                item.projectType = obj[item.category];
                                Object.assign(item,item.dicCounty);
                                delete item.id;
                                delete item.dicCounty
                            });
                            this.projectListK = res.data.data
                        }
                    }).catch(() => {
                        this.loadingK = false;
                    });
                } else {
                    this.projectListK = [];
                }
            },
            // 秘钥 弹窗
            handleKey() {
                this.myVisiable = true
            },
            // 秘钥 提交
            asyncOK() {
                this.$refs.modeForm.validate((valid) => {
                    if (valid) {
                        this.axios({
                            method: 'post',
                            url:'/project/applySecretKeyByProject',
                            data: this.modeForm
                        }).then((res) => {
                            if (res.data.success) {
                                this.$Message.success({
                                    content: '申请成功'
                                });
                                this.asyncCancel();
                                this.handleReset()
                            } else {
                                this.$Message.warning({
                                    content: res.data.errorMsg || '申请失败'
                                })
                            }
                        })
                    }
                })
            },
            // 秘钥 取消
            asyncCancel() {
                this.$refs.modeForm.resetFields();
                this.modeForm = {
                    projectId: '', // 项目名称
                    /* 静态< */
                    projectName: '', // 项目名称
                    projectAreaCode: '', // 项目地区code
                    projectType: '',
                    areaName: '',
                    buildCorpName: '',
                    buildCorpCode: '',
                    constructionName: '',
                    buildName: '',
                    buildCreditCode: '',
                    /* > */
                    applicantName: '', // 申请人姓名
                    applicantMobile: '', // 联系电话
                    email: '',  // 邮件
                    remark: ''   // 备注
                };
                this.myVisiable = false;
            },
            disabledDateStart(val) {
                return new Date(this.formInline['endDate'] || '').getTime() < val.getTime()
            },
            disabledDateEnd(val) {
                return new Date(this.formInline['startDate'] || '').getTime() > val.getTime()
            },
            handleStartDate(val) {
                this.formInline['createTime'] = val
            },
            handleEndDate(val) {
                this.formInline['endDate'] = val
            },
            handleReset() {
                this.page = 1
                this.formInline = {
                    startNum: 1,
                    size: 10,
                    builderLicenseNum: '', //申请人姓名
                    applicantName: '', //申请人姓名
                    createTime: '', //申请时间
                    disabled: '',			// 默认传0：启用，1停用
                    projectName: '', //项目名称
                    projectType: '', //工程类别：1：房建，2市政，3其他
                    areaCode: getCookie('tenantAreaCode'), //区划代码 默认传：cookie里的：tenantAreaCode
                };
                this.getTableData()
            },
            //导出
            handleExport(nameValue){
                const { startNum, size, applicantName, createTime, disabled, projectName, projectType, areaCode, builderLicenseNum } = this.formInline
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/project/secretKey/export',
                    responseType:'arraybuffer',
                    data: {
                        startNum: this.page,
                        size: this.pageSize,
                        applicantName,
                        applicantStatus: this.applicantStatus || null,
                        createTime,
                        disabled,
                        projectName,
                        projectType,
                        areaCode,
                        builderLicenseNum,
                    },
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response, '秘钥管理.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleConfirm(row){
                this.$Modal.confirm({
                    title: '提示',
                    content: `确定要${row.disabled == 0 ? '停用' : '启用'}该项目的秘钥吗？`,
                    onOk: () => {
                      this.axios({
                        method: 'post',
                        url: '/project/secretKey/disabled',
                        data: {
                            id: row.id,
                            disabled: row.disabled == 0 ? 1 : 0
                        }
                      }).then((res) => {
                        if (res.data.success) {
                          this.$Message.success({
                            content: '操作成功'
                          })
                          this.getTableData()
                        } else {
                          this.$Message.warning({
                            content: '操作失败'
                          })
                        }
                      })
                    },
                    onCancel: () => {
                    }
                });
            },
            /*获取表格数据*/
            getTableData(nameValue){
                const { applicantName, createTime, disabled, projectName, projectType, areaCode,builderLicenseNum } = this.formInline
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/project/secretKey/pageList',
                    data: {
                        startNum: this.page,
                        size: this.pageSize,
                        applicantStatus: this.applicantStatus || null,
                        applicantName,
                        createTime,
                        disabled,
                        projectName,
                        projectType,
                        areaCode,
                        builderLicenseNum,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        response.data.data.records.forEach(item => {
                            item.loading = false;
                        });
                        this.totalCount = response.data.data.total
                        this.tableData = response.data.data.records
                    }
                }).catch(()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
